/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-audit-item.reducer';

export const PharmacyAuditItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyAuditItemEntity = useAppSelector(state => state.pharmacyAuditItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyAuditItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.detail.title">PharmacyAuditItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditItemEntity.id}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditItemEntity.quantity}</dd>
          <dt>
            <span id="expectedQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.expectedQty">Expected Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditItemEntity.expectedQty}</dd>
          <dt>
            <span id="qtyType">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.qtyType">Qty Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditItemEntity.qtyType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditItemEntity.lastupdated}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditItemEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyAuditItemEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.summary">Summary</Translate>
          </dt>
          <dd>{pharmacyAuditItemEntity.summary ? pharmacyAuditItemEntity.summary.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.drugStock">Drug Stock</Translate>
          </dt>
          <dd>{pharmacyAuditItemEntity.drugStock ? pharmacyAuditItemEntity.drugStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.consumableStock">Consumable Stock</Translate>
          </dt>
          <dd>{pharmacyAuditItemEntity.consumableStock ? pharmacyAuditItemEntity.consumableStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.implantStock">Implant Stock</Translate>
          </dt>
          <dd>{pharmacyAuditItemEntity.implantStock ? pharmacyAuditItemEntity.implantStock.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-audit-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-audit-item/${pharmacyAuditItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyAuditItemDetail;
